import { store } from 'redux/store';
import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
export async function GetProducts(
    projectId,
    status = '',
    type = '',
    page = 1,
    search = '',
    sortBy,
    sortOrder
) {
    const user = store?.getState()?.user;
    if (isAuthenticated() && user) {
        const response = await apiInterceptor(
            `${
                process.env.REACT_APP_MYXP_API
            }/manager/livestream/products?projectId=${projectId}&status=${status}&limit=10&page=${page}&search=${search}${
                sortBy ? `&sortBy=${sortBy}` : ''
            }${sortOrder ? `&sortOrder=${sortOrder}` : ''}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return await response.json();
    }
}
